"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Button;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getSize(variant) {
  switch (variant) {
    case 'appPrimary':
    case 'appSecondary':
      return 'small';

    default:
      return 'large';
  }
}

function getWidth(variant) {
  switch (variant) {
    case 'appPrimary':
    case 'appSecondary':
      return 'small';

    default:
      return 'medium';
  }
}

function getCorners(variant) {
  switch (variant) {
    case 'appPrimary':
    case 'appSecondary':
      return true;

    default:
      return false;
  }
}

function getOutline(variant) {
  switch (variant) {
    case 'secondary':
    case 'appSecondary':
      return true;

    default:
      return false;
  }
}

function getColor(variant) {
  switch (variant) {
    case 'secondary':
    case 'appPrimary':
    case 'appSecondary':
      return 'gray';

    case 'tertiary':
      return 'transparent';

    case 'destructive':
      return 'red';

    default:
      return 'blue';
  }
}
/**
 * A good-looking button!
 *
 * The rendered element will be a `<button>` or an `<a>`, depending on whether
 * you provide an `href` prop or not.
 *
 * If you'd like to put an icon before or after the text of your button,
 * use [IconText](#icontext) for the content.
 */


function Button(_ref) {
  var _classnames;

  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      ariaLabel = _ref.ariaLabel,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? getSize(variant) : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? getWidth(variant) : _ref$width,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? getColor(variant) : _ref$color,
      _ref$outline = _ref.outline,
      outline = _ref$outline === void 0 ? getOutline(variant) : _ref$outline,
      _ref$corners = _ref.corners,
      corners = _ref$corners === void 0 ? getCorners(variant) : _ref$corners,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? false : _ref$block,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      onClick = _ref.onClick,
      passthroughProps = _ref.passthroughProps,
      href = _ref.href,
      children = _ref.children;
  var isSmall = size === 'small';
  var isMedium = size === 'medium';
  var isLarge = size === 'large';
  var widthSmall = width === 'small';
  var widthMedium = width === 'medium';
  var widthLarge = width === 'large';
  var classes = (0, _classnames2.default)('btn', (_classnames = {}, _defineProperty(_classnames, "btn--".concat(color), color), _defineProperty(_classnames, 'btn--stroke', outline), _defineProperty(_classnames, 'link link--gray transition', variant === 'tertiary'), _defineProperty(_classnames, "round", corners), _defineProperty(_classnames, 'round-full', !corners), _defineProperty(_classnames, "h24", isSmall), _defineProperty(_classnames, "py12", isLarge), _defineProperty(_classnames, "py6", isMedium), _defineProperty(_classnames, "px6", widthSmall && isSmall), _defineProperty(_classnames, "px12", widthMedium && isSmall || widthSmall && !isSmall), _defineProperty(_classnames, "px24", widthLarge && isSmall || widthMedium && !isSmall), _defineProperty(_classnames, "px36", !isSmall && widthLarge), _defineProperty(_classnames, 'w-full block', width === 'full'), _defineProperty(_classnames, "block", block), _defineProperty(_classnames, 'txt-s', !isSmall), _defineProperty(_classnames, 'py3 txt-xs', isSmall), _classnames));

  var universalProps = _objectSpread({
    className: classes,
    'aria-label': ariaLabel ? ariaLabel : variant,
    onClick: onClick
  }, passthroughProps);

  if (href) {
    return /*#__PURE__*/_react.default.createElement("a", _extends({
      href: href
    }, universalProps), children);
  } // "disabled" is not a valid attributes for anchors.


  var buttonProps = _objectSpread(_objectSpread({}, universalProps), {}, {
    children: children,
    disabled: disabled
  });

  return /*#__PURE__*/_react.default.createElement("button", _extends({
    type: "button"
  }, buttonProps));
}

Button.propTypes = {
  /**
   * The button's content. A string is recommended, but you can put an element
   * in here if you think that's right. If you do, it should be inline-level,
   * using `<span>`s instead of `<div>`s. ([IconText](#icontext) is
   * inline-level.)
   */
  children: _propTypes.default.node.isRequired,

  /**
   * A keyword identifying the standard button styling variant to use.
   *
   * *The variant is a starting point*: all of the other styling props can be
   * used to override details.
   *
   * The following variants are available:
   *
   * - `"primary"`: For primary actions.
   * - `"secondary"`: For secondary actions.
   * - `"tertiary"`: For downplayed actions, the ones people shouldn't
   *   usually want to perform, like cancelling instead of confirming.
   * - `"destructive"`: For destructive actions, like deleting something.
   * - `"appPrimary"`: For primary actions in dense apps.
   * - `"appSecondary"`: For secondary actions in dense apps.
   */
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'tertiary', 'destructive', 'appPrimary', 'appSecondary']),

  /**
   * A callback that receives the click event.
   *
   * You definitely need this if you don't use `href`; but you can also provide
   * both `onClick` and `href`, and `onClick` will be called when the `<a>` is
   * clicked.
   */
  onClick: _propTypes.default.func,

  /**
   * A URL. If `href` is provided, the button will be an `<a>`.
   */
  href: _propTypes.default.string,

  /**
   * The size of the button: `"small"`, `"medium"`, or `"large"`.
   *
   * This accounts for height, outline thickness, text size, and other details.
   *
   * This will override whichever defaults are set by your `variant` of choice.
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),

  /**
   * The width of the button: `"small"`, `"medium"`, `"large"`, or `"full"`.
   * For every option but `"full"` this prop determines horizontal padding.
   * `"full"` sets the button to fill the width of its container.
   *
   * This is distinguished from `size` because buttons of the same general size
   * can vary by width.
   *
   * This will override whichever defaults are set by your `variant` of choice.
   */
  width: _propTypes.default.oneOf(['small', 'medium', 'large', 'full']),

  /**
   * If `true`, the button will be outlined instead of filled with color.
   */
  outline: _propTypes.default.bool,

  /**
   * The Assembly color of the button.
   */
  color: _propTypes.default.string,

  /**
   * If `true`, the button will have (slightly rounded) corners instead of
   * the full curve they have by default.
   */
  corners: _propTypes.default.bool,

  /**
   * If `true`, the element will be `block` displayed instead of `inline-block`.
   *
   * This is sometimes necessary to get your pixel-perfect layout, if you don't
   * want the extra line-height that wraps inline elements. Typically, you
   * should only set `block` to `true` if the parent element is controlling
   * width (in a layout that uses flexbox, absolute positioning, or floats).
   */
  block: _propTypes.default.bool,

  /**
   * Is it disabled?
   */
  disabled: _propTypes.default.bool,

  /**
   * An object of props that you want to pass through to the element that
   * Button renders. This can be useful if you want to disable
   * the button, assign an ID for testing, add an ARIA attribute, toss in some
   * custom style properties, etc.
   */
  passthroughProps: _propTypes.default.object
};